/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvseType } from './EvseType';
import {
    EvseTypeFromJSON,
    EvseTypeFromJSONTyped,
    EvseTypeToJSON,
    EvseTypeToJSONTyped,
} from './EvseType';

/**
 * 
 * @export
 * @interface CreateAssetRequestDto
 */
export interface CreateAssetRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAssetRequestDto
     */
    assetName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetRequestDto
     */
    serialNumber: string;
    /**
     * Organization business identifier (e.g. CH-001)
     * @type {string}
     * @memberof CreateAssetRequestDto
     */
    tenantAssetId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetRequestDto
     */
    manufacturerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetRequestDto
     */
    siteId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetRequestDto
     */
    zoneId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetRequestDto
     */
    assetTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetRequestDto
     */
    assetModelId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetRequestDto
     */
    parentAssetId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateAssetRequestDto
     */
    installedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateAssetRequestDto
     */
    commissionedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateAssetRequestDto
     */
    decommissionedAt?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof CreateAssetRequestDto
     */
    expectedDailyEarning?: number;
    /**
     * 
     * @type {EvseType}
     * @memberof CreateAssetRequestDto
     */
    standard?: EvseType | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAssetRequestDto
     */
    landlordOrganizationId?: string | null;
}



/**
 * Check if a given object implements the CreateAssetRequestDto interface.
 */
export function instanceOfCreateAssetRequestDto(value: object): value is CreateAssetRequestDto {
    if (!('assetName' in value) || value['assetName'] === undefined) return false;
    if (!('serialNumber' in value) || value['serialNumber'] === undefined) return false;
    if (!('siteId' in value) || value['siteId'] === undefined) return false;
    if (!('assetTypeId' in value) || value['assetTypeId'] === undefined) return false;
    return true;
}

export function CreateAssetRequestDtoFromJSON(json: any): CreateAssetRequestDto {
    return CreateAssetRequestDtoFromJSONTyped(json, false);
}

export function CreateAssetRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAssetRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'assetName': json['assetName'],
        'serialNumber': json['serialNumber'],
        'tenantAssetId': json['tenantAssetId'] == null ? undefined : json['tenantAssetId'],
        'manufacturerId': json['manufacturerId'] == null ? undefined : json['manufacturerId'],
        'siteId': json['siteId'],
        'zoneId': json['zoneId'] == null ? undefined : json['zoneId'],
        'assetTypeId': json['assetTypeId'],
        'assetModelId': json['assetModelId'] == null ? undefined : json['assetModelId'],
        'parentAssetId': json['parentAssetId'] == null ? undefined : json['parentAssetId'],
        'installedAt': json['installedAt'] == null ? undefined : (new Date(json['installedAt'])),
        'commissionedAt': json['commissionedAt'] == null ? undefined : (new Date(json['commissionedAt'])),
        'decommissionedAt': json['decommissionedAt'] == null ? undefined : (new Date(json['decommissionedAt'])),
        'expectedDailyEarning': json['expectedDailyEarning'] == null ? undefined : json['expectedDailyEarning'],
        'standard': json['standard'] == null ? undefined : EvseTypeFromJSON(json['standard']),
        'landlordOrganizationId': json['landlordOrganizationId'] == null ? undefined : json['landlordOrganizationId'],
    };
}

export function CreateAssetRequestDtoToJSON(json: any): CreateAssetRequestDto {
    return CreateAssetRequestDtoToJSONTyped(json, false);
}

export function CreateAssetRequestDtoToJSONTyped(value?: CreateAssetRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetName': value['assetName'],
        'serialNumber': value['serialNumber'],
        'tenantAssetId': value['tenantAssetId'],
        'manufacturerId': value['manufacturerId'],
        'siteId': value['siteId'],
        'zoneId': value['zoneId'],
        'assetTypeId': value['assetTypeId'],
        'assetModelId': value['assetModelId'],
        'parentAssetId': value['parentAssetId'],
        'installedAt': value['installedAt'] == null ? value['installedAt'] : value['installedAt'].toISOString(),
        'commissionedAt': value['commissionedAt'] == null ? value['commissionedAt'] : value['commissionedAt'].toISOString(),
        'decommissionedAt': value['decommissionedAt'] == null ? value['decommissionedAt'] : value['decommissionedAt'].toISOString(),
        'expectedDailyEarning': value['expectedDailyEarning'],
        'standard': EvseTypeToJSON(value['standard']),
        'landlordOrganizationId': value['landlordOrganizationId'],
    };
}

